import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useQueryParams = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const getQuery = useMemo(() => new URLSearchParams(search), [search]);
  const setQuery = useCallback(
    (name: string, value: string) =>
      navigate({
        search: `?${new URLSearchParams({ [name]: value })}`,
      }),
    [navigate]
  );

  const clearQuery = useCallback(
    () =>
      navigate({
        search: '',
      }),
    [navigate]
  );

  return {
    getQuery,
    setQuery,
    clearQuery,
  };
};

export default useQueryParams;
